<template>
  <div class="card">

    <div class="card-header header-elements-inline" >
      <h5 class="card-title">Yarn Creation</h5>
      <div class="header-elements">
        <div class="list-icons">

          <a class="list-icons-item" data-action="reload" @click="loadAll"></a>
          <a class="list-icons-item" data-action="remove" @click="closeWindow"></a>
        </div>
      </div>
    </div>

    <div class="card-body">
      <form action="#">

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Count:</label>
          <div class="col-md-10" >
            <select class="form-control"v-if="yarn" v-model="yarn.count.code" autofocus="">
              <option v-for="count in counts" v-bind:value="count.code">
                {{ count.name }}
              </option>
            </select>
          </div>
        </div>



        <div class="form-group row">
          <label class="col-md-2 col-form-label">Design:</label>
          <div class="col-md-4">
            <select class="form-control" v-if="yarn" v-model="yarn.design.code" >
              <option value="1">-</option>
              <option v-for="design in designs" v-bind:value="design.code">
                {{ design.name }}
              </option>
            </select>
          </div>

          <label class="col-md-1 col-form-label">Color:</label>
          <div class="col-md-5">
            <select class="form-control" v-if="yarn" v-model="yarn.color.code">
              <option value="1">-</option>
              <option v-for="color in colors" v-bind:value="color.code">
                {{ color.name }}
              </option>
            </select>
          </div>
        </div>


        <div class="form-group row">

          <label class="col-md-2 col-form-label">Weight:</label>
          <div class="col-md-10">
            <input type="number" class="form-control text-right" placeholder="Weight / Unit" min="0"  max="100" v-if="yarn" v-model="yarn.weight">
          </div>

        </div>

        <div class="form-group row">
          <label class="col-md-2 col-form-label">Print Name:</label>
          <div class="col-md-10">
            <input type="text" class="form-control" placeholder="Enter your print name here..." maxlength="100" v-if="yarn" v-model="yarn.p_name">
          </div>
        </div>


      </form>
    </div>

    <div class="card-footer">
      <div class="text-right" >
        <button type="button" class="btn btn-primary" @click="saveDocument" >Save<i class="icon-paperplane ml-2"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
  import {userService} from '@/store/auth-header.js'
  export default {
    name: 'YarnForm',
    data () {
      return {
        yarn: JSON.parse('{"id":"","code":0,"status":0,"type":0,"process":{"id":"","code":0,"name":"","nature":0,"sname":"","sys_obj":false},"count":{"id":"","code":1,"type":0,"status":0,"name":"","p_name":"","hsn":"","gst_rate":0,"itc_rate":0,"main_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"conv_fact":0,"sub_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"weight":0},"name":"","design":{"id":"","code":1,"name":"","p_name":""},"color":{"id":"","code":1,"status":0,"name":"","print_name":""},"pantone":"","p_name":"","weight":0}'),
        counts: [],
        designs: [],
        colors:[]
      }
    },
    props: {
      myyarn: {
        type: Object,
        default: () => JSON.parse('{"id":"","code":0,"status":0,"type":0,"process":{"id":"","code":0,"name":"","nature":0,"sname":"","sys_obj":false},"count":{"id":"","code":1,"type":0,"status":0,"name":"","p_name":"","hsn":"","gst_rate":0,"itc_rate":0,"main_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"conv_fact":0,"sub_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"weight":0},"name":"","design":{"id":"","code":1,"name":"","p_name":""},"color":{"id":"","code":1,"status":0,"name":"","print_name":""},"pantone":"","p_name":"","weight":0}')
      }
    },
    beforeMount () {
      this.yarn = this.myyarn; // save props data to itself's data and deal with tms
    },
    component: {

    },
    created () {
      this.$data.yarn = JSON.parse('{"id":"","code":0,"status":0,"type":0,"process":{"id":"","code":0,"name":"","nature":0,"sname":"","sys_obj":false},"count":{"id":"","code":1,"type":0,"status":0,"name":"","p_name":"","hsn":"","gst_rate":0,"itc_rate":0,"main_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"conv_fact":0,"sub_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"weight":0},"name":"","design":{"id":"","code":1,"name":"","p_name":""},"color":{"id":"","code":1,"status":0,"name":"","print_name":""},"pantone":"","p_name":"","weight":0}')
    },
    mounted () {
      let self = this;
      $('.form-control-select2').select2()

      self.loadGroup();
      self.loadColors();
      self.loadDesigns();

    },
    methods: {
      closeWindow(){
        this.$parent.$parent.closeModal();
      },
      clear(){
        this.$data.yarn = JSON.parse('{"id":"","code":0,"status":0,"type":0,"process":{"id":"","code":0,"name":"","nature":0,"sname":"","sys_obj":false},"count":{"id":"","code":1,"type":0,"status":0,"name":"","p_name":"","hsn":"","gst_rate":0,"itc_rate":0,"main_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"conv_fact":0,"sub_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"weight":0},"name":"","design":{"id":"","code":1,"name":"","p_name":""},"color":{"id":"","code":1,"status":0,"name":"","print_name":""},"pantone":"","p_name":"","weight":0}');
      },
      loadAll(){
        loadGroup();
        loadColors();
        loadDesigns();

      },
      loadGroup(){
        let self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        fetch(`${process.env.VUE_APP_ROOT_API}v1/tms/count/`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.accepted) {
            self.$data.counts = resp.data;
          } else {
            swal ( { title: "Oh noes!" ,  text: resp.message, icon:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), icon:  "error"} );
        });

      },
      loadColors(){
        let self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        fetch(`${process.env.VUE_APP_ROOT_API}v1/tms/color/`,requestOptions).then(userService.handleResponse).then(function (data) {
          if(data.accepted) {
            self.$data.colors = data.data;
          } else {
            swal ( { title: "Oh noes!" ,  text: data.message, icon:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), icon:  "error"} );
        });

      },
      loadDesigns(){
        let self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        fetch(`${process.env.VUE_APP_ROOT_API}v1/tms/design/`,requestOptions).then(userService.handleResponse).then(function (data) {
          if(data.accepted) {
            self.$data.designs = data.data;
          } else {
            swal ( { title: "Oh noes!" ,  text: data.message, icon:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), icon:  "error"} );
        });
      },
      saveDocument(){
        let self = this;

        // self.$data.yarn.process.code = 305
        self.$data.yarn.design.code = parseInt(self.$data.yarn.design.code);
        //self.$data.yarn.style.code = parseInt(self.$data.yarn.style.code);
        self.$data.yarn.color.code = parseInt(self.$data.yarn.color.code);
        // self.$data.yarn.quality.code = parseInt(self.$data.yarn.quality.code);

        self.$data.yarn.weight = parseFloat(self.$data.yarn.weight);

        if(self.$data.yarn.design.code < 1){
          alert("Invalid Design");
          return
        }else if(self.$data.yarn.color.code < 1){
          alert("Invalid Color");
          return
        }

        const requestOptions = {
          method:  (self.$data.yarn.code == 0 ? 'POST' : 'PUT'),
          mode:"cors",
          headers: userService.authHeader(),
          body: JSON.stringify(self.$data.yarn)
        };

        fetch(`${process.env.VUE_APP_ROOT_API}v1/tms/yarn/`,requestOptions).then(userService.handleResponse).then(function (data) {
          if(data.accepted) {
            swal ( { title: "Success!" ,  text: data.message, icon:  "success"} );
            self.yarn = JSON.parse('{"id":"","code":0,"status":0,"type":0,"process":{"id":"","code":0,"name":"","nature":0,"sname":"","sys_obj":false},"count":{"id":"","code":1,"type":0,"status":0,"name":"","p_name":"","hsn":"","gst_rate":0,"itc_rate":0,"main_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"conv_fact":0,"sub_unit":{"id":"","code":0,"name":"","digits":0,"sys_obj":false},"weight":0},"name":"","design":{"id":"","code":1,"name":"","p_name":""},"color":{"id":"","code":1,"status":0,"name":"","print_name":""},"pantone":"","p_name":"","weight":0}');
            self.$parent.$parent.loadData();
            self.closeWindow();
          } else {
            swal ( { title: "Oh noes!" ,  text: data.message, icon:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), icon:  "error"} );
        });
      }
    }
  }
</script>

<style scoped>

</style>
